import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Search } from 'lucide-react';

const VegrHeader = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#2C4A5E] text-white shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <Link to="/vegr" className="flex items-center space-x-3 group">
            <img 
              src="https://customer-assets.emergentagent.com/job_uoe-highland/artifacts/pk36mmt7_Vegr%20roads%20app%20transparent.png" 
              alt="Vegr Logo" 
              className="w-12 h-12 transition-all group-hover:scale-110 filter brightness-0 invert"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
            <div>
              <h1 className="text-2xl font-bold">Vegr</h1>
              <p className="text-xs text-white/70">Highland Asia</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            <Link to="/vegr" className="hover:text-[#4A7C59] transition-colors">
              Home
            </Link>
            <Link to="/vegr/map" className="hover:text-[#4A7C59] transition-colors">
              Live Map
            </Link>
            <Link to="/vegr/reports" className="hover:text-[#4A7C59] transition-colors">
              All Reports
            </Link>
            <Link to="/vegr/about" className="hover:text-[#4A7C59] transition-colors">
              About
            </Link>
            <Link 
              to="/vegr/report" 
              className="bg-[#4A7C59] hover:bg-[#3d6949] px-6 py-2 rounded-lg transition-colors"
            >
              Report Condition
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 hover:bg-white/10 rounded-lg"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-[#1e3544] border-t border-white/10">
          <nav className="container mx-auto px-4 py-4 space-y-2">
            <Link
              to="/vegr"
              className="block px-4 py-3 hover:bg-white/10 rounded-lg transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/vegr/map"
              className="block px-4 py-3 hover:bg-white/10 rounded-lg transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Live Map
            </Link>
            <Link
              to="/vegr/reports"
              className="block px-4 py-3 hover:bg-white/10 rounded-lg transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              All Reports
            </Link>
            <Link
              to="/vegr/about"
              className="block px-4 py-3 hover:bg-white/10 rounded-lg transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              About
            </Link>
            <Link
              to="/vegr/report"
              className="block px-4 py-3 bg-[#4A7C59] hover:bg-[#3d6949] rounded-lg transition-colors text-center font-semibold"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Report Condition
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default VegrHeader;